export const MA_MD_DEBUG_PREFIX = "[MA-MD-SUB]";

// Keep CUSIP normalization in one place so the page, provider, and websocket
// layer all compare the same canonical values.
export const normalizeCusip = (cusip) => {
  if (cusip == null) return "";
  return String(cusip).trim().toUpperCase();
};

export const normalizeCusipList = (cusips = []) => {
  const normalized = cusips
    .map(normalizeCusip)
    .filter(Boolean);

  return Array.from(new Set(normalized));
};

export const buildMACusipTopicPath = (cusip) => `/topic/md-update/${normalizeCusip(cusip)}`;

export const diffCusipSets = (currentSet, nextSet) => {
  const current = currentSet instanceof Set ? currentSet : new Set(currentSet || []);
  const next = nextSet instanceof Set ? nextSet : new Set(nextSet || []);

  const toSubscribe = [];
  const toUnsubscribe = [];
  const unchanged = [];

  next.forEach((cusip) => {
    if (current.has(cusip)) {
      unchanged.push(cusip);
      return;
    }
    toSubscribe.push(cusip);
  });

  current.forEach((cusip) => {
    if (!next.has(cusip)) {
      toUnsubscribe.push(cusip);
    }
  });

  return {
    toSubscribe,
    toUnsubscribe,
    unchanged,
  };
};

// Renders a CUSIP collection for logs. Truncated so a 5k-row watchlist doesn't
// build a ~50 KB string on every reconcile/subscribe log line.
export const describeCusipCollection = (cusips = [], limit = 10) => {
  const normalized = Array.isArray(cusips)
    ? normalizeCusipList(cusips)
    : normalizeCusipList(Array.from(cusips || []));
  if (!normalized.length) return "<none>";
  if (normalized.length <= limit) return normalized.join(", ");
  return `${normalized.slice(0, limit).join(", ")}, … +${normalized.length - limit} more`;
};

export const createMAInventoryTraceId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `ma-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};
